import React from "react";

import { formGroup, formControl } from "bootstrap/dist/css/bootstrap.css";
import DataService from "./DataService";

class UploadBatchModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      detectionSettings: [],
      visualClassGroups: [],
      showAllDetSet: false
    };

    this.handleCheck = this.handleCheck.bind(this)
  }

  async componentWillMount() {
    const detectionSettings = await DataService.getDetectionSettings();

    this.setState({
      detectionSettings
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.detectionSettingId && nextProps.detectionSettingId !== this.props.detectionSettingId) {
      this.onDetSetChange(nextProps.detectionSettingId)
    }
  }

  async onDetSetChange(detectionSettingId) {
    let visualClassGroups = await DataService.getDetectionSettingVisualClassGroup(
      detectionSettingId
    );

    if (visualClassGroups === null) {
      visualClassGroups = [];
    } else if (visualClassGroups.length > 0) {
      // It's an array! Yay! Do nothing!
    } else if (typeof visualClassGroups === "object") {
      visualClassGroups = [visualClassGroups];
    }

    this.setState({
      visualClassGroups,
      selectedDetectionSettingId: detectionSettingId,
      visualClassGroupId: ""
    });
  }

  handleCheck() {
    this.setState({
      showAllDetSet: !this.state.showAllDetSet
    })
  }

  render() {
    const { detectionSettings, visualClassGroups, selectedDetectionSettingId, visualClassGroupId, showAllDetSet } = this.state;
    const { onBatchUploadClick } = this.props;

    var detectionSettingFiltered = detectionSettings
    if(!showAllDetSet) {
      detectionSettingFiltered = detectionSettings.filter(ds => ds.deployment && ds.deployment.some(e => e.status === 1))
    }

    return (
      <div>
        <div
          className="modal fade"
          id="exampleModalCenter"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLongTitle">
                  Upload batch for...
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className={`${formGroup}`}>
                  <label htmlFor="detectionSettingSelect">Detection setting</label>
                  <select
                    className={`${formControl}`}
                    id="detectionSettingSelect"
                    onChange={(event) => this.onDetSetChange(event.target.value)}
                    value={selectedDetectionSettingId || ""}
                  >
                    <option value="" selected disabled>Select detection setting...</option>
                    {detectionSettingFiltered.map(detectionSetting => (
                      <option
                        key={detectionSetting.id}
                        value={detectionSetting.id}
                      >
                        {`${detectionSetting.service} (${detectionSetting.id}) - ${detectionSetting.developer ? detectionSetting.developer.company.name : ""}`}
                      </option>
                    ))}
                  </select>
                  <input type="checkbox" name="allDetSet" value="AllDetSet" onChange={this.handleCheck}/> Show all Detection setting
                </div>
                <div className={`${formGroup}`}>
                  <label htmlFor="visualClassGroupSelect">
                    Visual class group
                  </label>
                  <select
                    className={`${formControl}`}
                    id="visualClassGroupSelect"
                    value={visualClassGroupId}
                    onChange={e => this.setState({visualClassGroupId: e.target.value})}
                  >
                    <option value="" selected disabled>Select visual class group...</option>
                    {visualClassGroups.map(visualClassGroup => (
                      <option
                        key={visualClassGroup.id}
                        value={visualClassGroup.id}
                      >
                        {`${visualClassGroup.name} (${visualClassGroup.id})`}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={!visualClassGroupId || !selectedDetectionSettingId}
                  onClick={() =>
                    onBatchUploadClick(
                      visualClassGroupId,
                      selectedDetectionSettingId
                    )
                  }
                >
                  Upload batch
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UploadBatchModal;



// WEBPACK FOOTER //
// ./src/UploadBatchModal.js